import apiClient from '../../../common/functions/api_axios_instance.function';

export const getSystemPoItemDetails = async (poId) => {
  try {
    const response = await apiClient.get(
      `/systemInvoiceManagement/purchaseOrderManagement/po-item-details/${poId}`
    );
    if (response.status === 200) {
      return {
        success: true,
        data: response.data?.response || response.data?.data || response.data,
        message: response.data?.message || 'PO item details fetched successfully',
      };
    }
    return {
      success: false,
      status: response.status,
      error: response.data?.message || response.data?.error || 'Failed to fetch PO item details',
    };
  } catch (error) {
    return {
      success: false,
      status: error?.response?.status,
      error:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'Failed to fetch PO item details',
    };
  }
};
